/**
 * Service Worker 注册脚本
 * 功能：注册 Service Worker，处理更新和离线支持
 */

(function() {
  'use strict';

  // 仅在支持 Service Worker 的浏览器中运行
  if (!('serviceWorker' in navigator)) {
    console.log('[SW] Service Worker not supported');
    return;
  }

  // 配置
  const SW_CONFIG = {
    scope: '/',
    // 检查更新的间隔（毫秒）
    updateInterval: 60 * 60 * 1000, // 1小时
    // 是否显示更新提示
    showUpdateNotification: true
  };

  let swRegistration = null;
  let isRefreshing = false;

  // ==========================================
  // 初始化注册
  // ==========================================
  function init() {
    // 等待页面加载完成后再注册 SW，避免影响首屏性能
    if (document.readyState === 'complete') {
      registerServiceWorker();
    } else {
      window.addEventListener('load', registerServiceWorker);
    }
  }

  // ==========================================
  // 注册 Service Worker
  // ==========================================
  async function registerServiceWorker() {
    try {
      // 延迟注册，确保不影响页面加载
      await delay(2000);

      const registration = await navigator.serviceWorker.register('/assets/service-worker.js', {
        scope: SW_CONFIG.scope
      });

      swRegistration = registration;
      console.log('[SW] Registered successfully:', registration.scope);

      // 监听 Service Worker 状态变化
      handleRegistration(registration);

      // 设置定期检查更新
      setInterval(() => {
        checkForUpdates();
      }, SW_CONFIG.updateInterval);

    } catch (error) {
      console.error('[SW] Registration failed:', error);
    }
  }

  // ==========================================
  // 处理注册状态
  // ==========================================
  function handleRegistration(registration) {
    // 监听新的 Service Worker 安装
    registration.addEventListener('updatefound', () => {
      const newWorker = registration.installing;
      
      console.log('[SW] New version found, installing...');

      newWorker.addEventListener('statechange', () => {
        // 新 worker 安装完成并等待激活
        if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
          console.log('[SW] New version ready to activate');
          
          if (SW_CONFIG.showUpdateNotification) {
            showUpdateNotification(newWorker);
          } else {
            // 静默更新
            skipWaitingAndRefresh(newWorker);
          }
        }
      });
    });

    // 检查当前状态
    if (registration.active) {
      console.log('[SW] Active');
    }
    if (registration.waiting) {
      console.log('[SW] Waiting to activate');
      if (SW_CONFIG.showUpdateNotification) {
        showUpdateNotification(registration.waiting);
      }
    }
  }

  // ==========================================
  // 检查更新
  // ==========================================
  async function checkForUpdates() {
    if (!swRegistration) return;

    try {
      await swRegistration.update();
      console.log('[SW] Checked for updates');
    } catch (error) {
      console.error('[SW] Update check failed:', error);
    }
  }

  // ==========================================
  // 显示更新提示
  // ==========================================
  function showUpdateNotification(worker) {
    // 避免重复显示
    if (document.getElementById('sw-update-toast')) return;

    const toast = document.createElement('div');
    toast.id = 'sw-update-toast';
    toast.innerHTML = `
      <div class="sw-update-content">
        <span>🎉 New version available!</span>
        <button id="sw-update-btn" class="sw-btn-update">Update Now</button>
        <button id="sw-dismiss-btn" class="sw-btn-dismiss">Later</button>
      </div>
    `;

    // 添加样式
    const style = document.createElement('style');
    style.textContent = `
      #sw-update-toast {
        position: fixed;
        bottom: 20px;
        right: 20px;
        background: #fff;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        border-radius: 8px;
        padding: 16px 20px;
        z-index: 999999;
        font-family: system-ui, -apple-system, sans-serif;
        animation: sw-slide-in 0.3s ease-out;
      }
      .sw-update-content {
        display: flex;
        align-items: center;
        gap: 12px;
        flex-wrap: wrap;
      }
      #sw-update-toast span {
        font-size: 14px;
        color: #333;
        font-weight: 500;
      }
      #sw-update-toast button {
        padding: 8px 16px;
        border: none;
        border-radius: 4px;
        font-size: 13px;
        cursor: pointer;
        transition: opacity 0.2s;
      }
      #sw-update-toast button:hover {
        opacity: 0.8;
      }
      .sw-btn-update {
        background: #000;
        color: #fff;
      }
      .sw-btn-dismiss {
        background: #f0f0f0;
        color: #666;
      }
      @keyframes sw-slide-in {
        from {
          transform: translateY(100px);
          opacity: 0;
        }
        to {
          transform: translateY(0);
          opacity: 1;
        }
      }
      @media (max-width: 480px) {
        #sw-update-toast {
          left: 10px;
          right: 10px;
          bottom: 10px;
        }
        .sw-update-content {
          justify-content: center;
        }
      }
    `;

    document.head.appendChild(style);
    document.body.appendChild(toast);

    // 绑定事件
    document.getElementById('sw-update-btn').addEventListener('click', () => {
      skipWaitingAndRefresh(worker);
      toast.remove();
    });

    document.getElementById('sw-dismiss-btn').addEventListener('click', () => {
      toast.remove();
    });

    // 5分钟后自动隐藏
    setTimeout(() => {
      if (toast.parentNode) {
        toast.style.animation = 'sw-slide-in 0.3s ease-out reverse';
        setTimeout(() => toast.remove(), 300);
      }
    }, 300000);
  }

  // ==========================================
  // 跳过等待并刷新页面
  // ==========================================
  function skipWaitingAndRefresh(worker) {
    if (!worker) return;

    // 监听 controller 变化
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (isRefreshing) return;
      isRefreshing = true;
      console.log('[SW] New controller, refreshing...');
      window.location.reload();
    });

    // 发送消息让 worker 跳过等待
    worker.postMessage({ type: 'SKIP_WAITING' });
  }

  // ==========================================
  // 监听来自 Service Worker 的消息
  // ==========================================
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data && event.data.type) {
      switch (event.data.type) {
        case 'CACHE_UPDATED':
          console.log('[SW] Cache updated:', event.data.payload);
          break;
        case 'OFFLINE_READY':
          console.log('[SW] App ready for offline use');
          break;
        case 'SYNC_COMPLETE':
          console.log('[SW] Background sync complete');
          break;
      }
    }
  });

  // ==========================================
  // 网络状态监听
  // ==========================================
  function setupNetworkStatusListeners() {
    let wasOffline = false;

    window.addEventListener('online', () => {
      if (wasOffline) {
        console.log('[SW] Back online');
        showNetworkStatus('online');
        wasOffline = false;
        
        // 触发后台同步
        if (swRegistration && 'sync' in swRegistration) {
          swRegistration.sync.register('sync-forms');
        }
      }
    });

    window.addEventListener('offline', () => {
      console.log('[SW] Gone offline');
      showNetworkStatus('offline');
      wasOffline = true;
    });
  }

  // ==========================================
  // 显示网络状态提示
  // ==========================================
  function showNetworkStatus(status) {
    // 避免重复显示
    const existing = document.getElementById('sw-network-status');
    if (existing) existing.remove();

    const toast = document.createElement('div');
    toast.id = 'sw-network-status';
    toast.innerHTML = status === 'online' 
      ? '<span>🟢 Back online</span>'
      : '<span>🔴 You are offline</span>';

    const style = document.createElement('style');
    style.textContent = `
      #sw-network-status {
        position: fixed;
        top: 20px;
        right: 20px;
        background: ${status === 'online' ? '#4caf50' : '#f44336'};
        color: #fff;
        padding: 10px 16px;
        border-radius: 4px;
        z-index: 999999;
        font-family: system-ui, -apple-system, sans-serif;
        font-size: 13px;
        animation: sw-fade-in-out 3s ease-in-out forwards;
      }
      @keyframes sw-fade-in-out {
        0% { opacity: 0; transform: translateY(-20px); }
        10% { opacity: 1; transform: translateY(0); }
        90% { opacity: 1; transform: translateY(0); }
        100% { opacity: 0; transform: translateY(-20px); }
      }
    `;

    document.head.appendChild(style);
    document.body.appendChild(toast);

    setTimeout(() => toast.remove(), 3000);
  }

  // ==========================================
  // 工具函数
  // ==========================================
  function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  // ==========================================
  // 公共 API
  // ==========================================
  window.ServiceWorkerManager = {
    // 手动检查更新
    checkForUpdates: checkForUpdates,
    
    // 获取注册信息
    getRegistration: () => swRegistration,
    
    // 清除缓存
    clearCache: async function() {
      if ('caches' in window) {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map(name => caches.delete(name)));
        console.log('[SW] All caches cleared');
      }
    },

    // 注销 Service Worker
    unregister: async function() {
      if (swRegistration) {
        await swRegistration.unregister();
        console.log('[SW] Unregistered');
      }
    }
  };

  // ==========================================
  // 启动
  // ==========================================
  init();
  setupNetworkStatusListeners();

})();
